import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "field is-grouped mt-1 mb-0" }
const _hoisted_2 = { class: "control mr-1" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "control" }
const _hoisted_5 = ["disabled", "title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon-plus" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["input", { 'is-danger': _ctx.createError.name }]),
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.setName) = $event)),
          disabled: !_ctx.hasContribPrivilege || _ctx.dataset.state !== 'open'
        }, null, 10, _hoisted_3), [
          [_vModelText, _ctx.setName]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["button is-primary", { 'is-loading': _ctx.loading }]),
          disabled: _ctx.loading || !_ctx.canCreate || undefined,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setCreate && _ctx.setCreate(...args))),
          title: _ctx.createTitle
        }, _hoisted_7, 10, _hoisted_5)
      ])
    ]),
    (_ctx.createError.name)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.createError.name, (err, i) => {
          return (_openBlock(), _createElementBlock("p", {
            key: i,
            class: "help has-text-danger"
          }, _toDisplayString(err), 1))
        }), 128))
      : _createCommentVNode("", true)
  ], 64))
}